var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisputed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.9166 101C58.9833 101 46.8333 88.85 46.8333 73.9167C46.8333 58.9833 58.9833 46.8333 73.9166 46.8333C88.8499 46.8333 101 58.9833 101 73.9167C101 88.85 88.8499 101 73.9166 101ZM73.9166 51C61.2791 51 50.9999 61.2833 50.9999 73.9167C50.9999 86.55 61.2791 96.8334 73.9166 96.8334C86.5541 96.8334 96.8333 86.55 96.8333 73.9167C96.8333 61.2833 86.5541 51 73.9166 51Z",
    fill: "#727272",
    stroke: "#727272",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9166 80.5C72.7666 80.5 71.8333 79.5667 71.8333 78.4167V61.75C71.8333 60.6 72.7666 59.6667 73.9166 59.6667C75.0666 59.6667 75.9999 60.6 75.9999 61.75V78.4167C75.9999 79.5667 75.0666 80.5 73.9166 80.5Z",
    fill: "#727272",
    stroke: "#727272",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9166 89.5C75.0672 89.5 75.9999 88.5672 75.9999 87.4166C75.9999 86.2661 75.0672 85.3333 73.9166 85.3333C72.766 85.3333 71.8333 86.2661 71.8333 87.4166C71.8333 88.5672 72.766 89.5 73.9166 89.5Z",
    fill: "#727272",
    stroke: "#727272",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5833 88.5H11.4167C5.675 88.5 1 83.8292 1 78.0833V23.9167C1 18.1708 5.675 13.5 11.4167 13.5H19.75C20.9 13.5 21.8333 14.4333 21.8333 15.5833C21.8333 16.7333 20.9 17.6667 19.75 17.6667H11.4167C7.97083 17.6667 5.16667 20.4708 5.16667 23.9167V78.0833C5.16667 81.5292 7.97083 84.3333 11.4167 84.3333H40.5833C41.7333 84.3333 42.6667 85.2667 42.6667 86.4167C42.6667 87.5667 41.7333 88.5 40.5833 88.5Z",
    fill: "#727272",
    stroke: "#727272",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9168 26H23.9168C20.4709 26 17.6667 23.1958 17.6667 19.75V11.4167C17.6667 10.2667 18.6001 9.33333 19.7501 9.33333H26.2084C27.1793 4.58333 31.3834 1 36.4168 1C41.4501 1 45.6543 4.58333 46.6251 9.33333H53.0834C54.2334 9.33333 55.1668 10.2667 55.1668 11.4167V19.75C55.1668 23.1958 52.3626 26 48.9168 26ZM21.8334 13.5V19.75C21.8334 20.8958 22.7668 21.8333 23.9168 21.8333H48.9168C50.0668 21.8333 51.0001 20.8958 51.0001 19.75V13.5H44.7501C43.6001 13.5 42.6668 12.5667 42.6668 11.4167C42.6668 7.97083 39.8626 5.16667 36.4168 5.16667C32.9709 5.16667 30.1668 7.97083 30.1668 11.4167C30.1668 12.5667 29.2334 13.5 28.0834 13.5H21.8334Z",
    fill: "#727272",
    stroke: "#727272",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.25 38.5H15.5833C14.4333 38.5 13.5 37.5666 13.5 36.4166C13.5 35.2666 14.4333 34.3333 15.5833 34.3333H57.25C58.4 34.3333 59.3333 35.2666 59.3333 36.4166C59.3333 37.5666 58.4 38.5 57.25 38.5Z",
    fill: "#727272",
    stroke: "#727272",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.75 51H15.5833C14.4333 51 13.5 50.0667 13.5 48.9167C13.5 47.7667 14.4333 46.8333 15.5833 46.8333H44.75C45.9 46.8333 46.8333 47.7667 46.8333 48.9167C46.8333 50.0667 45.9 51 44.75 51Z",
    fill: "#727272",
    stroke: "#727272",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4167 63.5H15.5833C14.4333 63.5 13.5 62.5666 13.5 61.4166C13.5 60.2666 14.4333 59.3333 15.5833 59.3333H36.4167C37.5667 59.3333 38.5 60.2666 38.5 61.4166C38.5 62.5666 37.5667 63.5 36.4167 63.5Z",
    fill: "#727272",
    stroke: "#727272",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.75 38.5C68.6 38.5 67.6667 37.5667 67.6667 36.4167V23.9167C67.6667 20.4708 64.8625 17.6667 61.4167 17.6667H53.0833C51.9333 17.6667 51 16.7333 51 15.5833C51 14.4333 51.9333 13.5 53.0833 13.5H61.4167C67.1583 13.5 71.8333 18.1708 71.8333 23.9167V36.4167C71.8333 37.5667 70.9 38.5 69.75 38.5Z",
    fill: "#727272",
    stroke: "#727272",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisputed);
export default __webpack_public_path__ + "static/media/disputed.170217438f43a59a9321e536b87c4acb.svg";
export { ForwardRef as ReactComponent };